import React, { useState, useRef, useEffect } from "react";
import {
  Overlay,
  Popover,
  Button,
  Spinner,
  OverlayTrigger,
  Tooltip,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import {
  Bell,
  ExclamationTriangleFill,
  ShieldLockFill,
  CheckCircle,
} from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import "./styles.scss";
import {
  getUserInformation,
  getUserPermission,
  getUserRole,
} from "../../store/userRole";
import { useSelector } from "react-redux";
import {
  getListOfAllNotifications,
  markAlllNotificationsAsRead,
  markAlllNotificationsAsSeen,
  markNotificationsAsRead,
} from "../../utils/discussions";
import { toast } from "react-toastify";
import withSubscriptionCheckButton from "../Common/withSubscriptionCheckButton";
import { isSafari } from "../../pages/StudentPages/LiveClasses/utils";
import { joinLiveClass } from "../../utils/liveClasses";
import Loader from "../Loader";
import { getUsedNotificationIconsList } from "../../constants/sidebar";
import ImportantIcon from "../../constants/ImportantIcon";
import {
  isEditOwnAccess,
  permissionsParser,
} from "../../utils/permissionsParser";
const StartClassButton = withSubscriptionCheckButton(Button, "Live Classes");

const NotificationPopover = ({
  isMobileView,
  // realTimeNotification = null,
  // setRealTimeNotification = () => {},
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const roleOfTheUser = useSelector(getUserRole);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [countOfPage, setCountOfPage] = useState(0);
  const userInformation = useSelector(getUserInformation);
  const [toastNotification, setToastNotification] = useState(null);
  const [seeAbleCount, setSeeAbleCount] = useState(0);
  const rolePermissions = useSelector(getUserPermission);
  const permissions = permissionsParser("Live Classes", rolePermissions);

  const target = useRef(null);
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (realTimeNotification) {
  //     const formatted = {
  //       id: realTimeNotification?._id,
  //       title: realTimeNotification.title || "Notification",
  //       description:
  //         generateDescForNotification(realTimeNotification) ||
  //         "You have a new update.",
  //       createdAt: realTimeNotification.createdAt,
  //       hasRead: realTimeNotification.hasRead,
  //       priority: realTimeNotification.priority || "Normal",
  //       notificationCategory: realTimeNotification.notificationCategory,
  //       classroomId: realTimeNotification?.classroomId,
  //       data: realTimeNotification?.data,
  //       actionType: "",
  //     };

  //     setNotifications((prev) => [formatted, ...prev]);
  //     setToastNotification(formatted);
  //     setSeeAbleCount((prev) => prev + 1);
  //     setRealTimeNotification(null);
  //   }
  // }, [realTimeNotification, setRealTimeNotification]);

  const generateDescForNotification = (notif) => {
    const date = new Date(notif?.data?.startDateTime);

    const formatted = date.toLocaleString("en-US", {
      month: "numeric",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
    if (notif?.notificationCategory === "newAnnouncement") {
      return `New update: Check the latest announcement.`;
    } else if (notif?.notificationCategory === "liveclassRescheduled") {
      return `Your class "${notif?.data?.name}" has been rescheduled to ${formatted}.`;
    }
    return notif.description;
  };

  const getNotificationsList = async () => {
    try {
      setLoading(true);
      const response = await getListOfAllNotifications({
        page: page,
        pageSize: 10,
      });
      if (response?.notSeenCount) {
        setSeeAbleCount(response.notSeenCount);
      }
      setNotifications([
        ...notifications,
        ...response?.notifications?.map((newNotif) => ({
          id: newNotif?._id,
          title: newNotif.title || "Notification",
          description:
            generateDescForNotification(newNotif) || "You have a new update.",
          createdAt: newNotif.createdAt,
          hasRead: newNotif.hasRead,
          priority: newNotif.priority || "Normal",
          notificationCategory: newNotif.notificationCategory,
          data: newNotif?.data,
          classroomId: newNotif?.classroomId,
          actionType: "",
        })),
      ]);
      setCountOfPage(Math.ceil(response?.count / 10));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching notifications: ", error.message);
    }
  };

  const markNotificationAsRead = async (notificationId) => {
    try {
      const response = await markNotificationsAsRead(
        notificationId,
        JSON.stringify({
          markAsRead: true,
        })
      );
      if (response?.notification) {
        // do nothing
      } else {
        toast.error(
          `Unable to mark the notification as read. Please try again after loading page.`
        );
      }
    } catch (err) {
      toast.error(
        `Unable to mark the notification as read. Please try again after loading page.`
      );
    }
  };

  const markALLNotificationsAsRead = async () => {
    try {
      const response = await markAlllNotificationsAsRead();
      if (response?.message === "Successfully markAllAsRead done") {
        // do nothing
      } else {
        toast.error(
          `Unable to mark all the notifications as read. Please try again after loading page.`
        );
      }
    } catch (err) {
      toast.error(
        `Unable to mark the notification as read. Please try again after loading page.`
      );
    }
  };

  const markNotificationsAsSeen = async () => {
    try {
      const response = await markAlllNotificationsAsSeen();
      setSeeAbleCount(0);
      if (response?.message === "Successfully markAllAsSeen done") {
        // do nothing
      } else {
        toast.error(
          `Unable to mark all the notifications as read. Please try again after loading page.`
        );
      }
    } catch (err) {
      toast.error(
        `Unable to mark the notification as read. Please try again after loading page.`
      );
    }
  };

  useEffect(() => {
    if (show) {
      markNotificationsAsSeen();
    }
  }, [show]);

  useEffect(() => {
    getNotificationsList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const getRelativeTime = (date) => {
    const now = new Date();
    const diff = Math.floor((now - new Date(date)) / 1000);
    if (diff < 60) return `${diff}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return new Date(date).toLocaleString();
  };

  const handleToggle = () => {
    setShow(!show);
  };

  const handleRedirect = (link) => {
    setShow(false);
    navigate(link);
  };

  const markAllAsRead = () => {
    setNotifications((prev) => prev.map((n) => ({ ...n, hasRead: true })));
    markALLNotificationsAsRead();
  };
  const unreadCount = notifications.filter((n) => !n.hasRead).length;

  const renderIcon = (priority, category) => {
    if (category === "subscriptionExpireReminder") {
      return <ImportantIcon size={28} />;
    }
    const usedIcon = getUsedNotificationIconsList({}, category);
    if (usedIcon) {
      return usedIcon;
    }
    return <Bell className="text-info me-2 fs-5" />;
  };

  const startLiveClass = async (liveclassid, meetingId, password, notif) => {
    const isSafariBrowser = isSafari();
    try {
      setIsLoading(true);
      await onNotificationClick(notif);
      const formatData = { meetingID: meetingId, password: password };
      const payload = JSON.stringify(formatData);
      const response = await joinLiveClass(liveclassid, payload, "join");
      if (isSafariBrowser) {
        if (response.data.url) {
          window.location.href = response?.data?.url;
        }
      } else {
        if (response.data.url) {
          window.open(response.data.url, "_blank", "noopener,noreferrer");
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching classrooms:", error.message);
      // Handle error, show a message to the user, etc.
    }
  };

  const renderActionButton = (notif) => {
    if (notif.hasRead && !notif.actionType) {
      return (
        <OverlayTrigger overlay={<Tooltip>Already Read</Tooltip>}>
          <CheckCircle className="text-success ms-2 fs-5" />
        </OverlayTrigger>
      );
    }

    const commonProps = {
      size: "md",
      className: "ms-2 px-3 py-1 rounded d-flex align-items-center",
      onClick: (e) => {
        e.stopPropagation();
        if (notif.actionType === "read") {
          setNotifications((prev) =>
            prev.map((n) => (n.id === notif.id ? { ...n, hasRead: true } : n))
          );
        } else {
          // handleRedirect(notif.link);
        }
      },
    };

    if (notif?.notificationCategory === "liveclassStarted" && !notif?.hasRead) {
      if (roleOfTheUser === "Student") {
        return (
          <StartClassButton
            onClick={async () => {
              startLiveClass(
                notif?.data?._id,
                notif?.data?.meetingID,
                notif?.data?.attendeePW,
                notif
              );
            }}
            classRoomId={notif?.classroomId}
            subjects={notif?.data?.subjects} // Pass the subjects array
          >
            Join
          </StartClassButton>
        );
      } else {
        // Convert to milliseconds
        const createdAtTime = new Date(notif?.createdAt).getTime();
        const durationMs = notif?.data?.duration * 60 * 1000;

        // Calculate expiry time
        const expiryTime = createdAtTime + durationMs;

        // Compare with current time
        const now = Date.now(); // or new Date().getTime()
        const isStillValid = now <= expiryTime;
        if (
          (permissions?.edit ||
            isEditOwnAccess(
              permissions,
              userInformation?._id,
              notif?.data?.createdBy
            )) &&
          isStillValid
        ) {
          return (
            <>
              <Button
                className="start-classroom-styles"
                variant="outline-primary"
                onClick={() =>
                  startLiveClass(
                    notif?.data?._id,
                    notif?.data?.meetingID,
                    notif?.data?.moderatorPW,
                    notif
                  )
                }
              >
                Join
              </Button>
            </>
          );
        }
      }
    }
    switch (notif.actionType) {
      case "join":
        return (
          <Button {...commonProps} variant="outline-success">
            Join
          </Button>
        );
      case "view":
        return (
          <Button {...commonProps} variant="outline-primary">
            View
          </Button>
        );
      case "open":
        return (
          <Button {...commonProps} variant="outline-info">
            Open
          </Button>
        );
      case "read":
        if (!notif.hasRead) {
          return (
            <OverlayTrigger overlay={<Tooltip>Mark as Read</Tooltip>}>
              <Button
                variant="outline-secondary"
                size="md"
                className="ms-2 px-2 py-1 rounded d-flex align-items-center justify-content-center"
                style={{ width: "36px", height: "36px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setNotifications((prev) =>
                    prev.map((n) =>
                      n.id === notif.id ? { ...n, hasRead: true } : n
                    )
                  );
                }}
              >
                <CheckCircle size={18} />
              </Button>
            </OverlayTrigger>
          );
        }
        return null;
      default:
        return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const getPopoverWidth = () => {
    if (typeof window !== "undefined" && window.innerWidth >= 1200) {
      return "520px";
    } else if (window.innerWidth >= 768) {
      return "460px";
    }
    return "100%";
  };

  const onNotificationClick = (notif) => {
    const txt = roleOfTheUser === "Student" ? "/student" : "";

    if (!notif?.hasRead) {
      setNotifications((prev) =>
        prev.map((n) => (n.id === notif.id ? { ...n, hasRead: true } : n))
      );
      markNotificationAsRead(notif.id);
    }
    if (notif?.notificationCategory === "newAnnouncement") {
      const link = `${txt}/myClassrooms/${notif?.data?.classroomId}/announcements`;
      setShow(false);
      navigate(link);
    } else if (notif?.notificationCategory === "fileAdded") {
      let link = "";
      if (notif?.data?.folderId) {
        link = `${txt}/myClassrooms/${notif?.data?.classroomId}/files/folders/${notif?.data?.folderId}`;
      } else {
        link = `${txt}/myClassrooms/${notif?.data?.classroomId}/files`;
      }
      setShow(false);
      navigate(link);
    } else if (
      notif?.notificationCategory === "liveclassRescheduled" ||
      notif?.notificationCategory === "liveclassSuspended" ||
      notif?.notificationCategory === "liveclassResumed"
    ) {
      const link = `${txt}/myClassrooms/${notif?.classroomId}/liveclasses?notificationConfig=true`;
      setShow(false);
      navigate(link);
    } else if (notif?.notificationCategory === "channelCreated") {
      const link = `${txt}/myClassrooms/${notif?.classroomId}/discussions`;
      setShow(false);
      navigate(link);
    } else if (notif?.notificationCategory === "channelQuestionAdded") {
      const link = `${txt}/myClassrooms/${notif?.classroomId}/discussions/${notif?.data?.channelId}?notificationConfig=true&questionId=${notif?.data?._id}`;
      setShow(false);
      navigate(link);
    } else if (notif?.notificationCategory === "channelAnswerAdded") {
      const link = `${txt}/myClassrooms/${notif?.classroomId}/discussions/${notif?.data?.channelId}?notificationConfig=true&questionId=${notif?.data?.questionId}&answerId=${notif?.data?._id}`;
      setShow(false);
      navigate(link);
    } else if (notif?.notificationCategory === "practiceSetAdded") {
      const link = `${txt}/myClassrooms/${notif?.classroomId}/practice?notificationConfig=true&subj=${notif?.data?.subjectId}&sec=${notif?.data?.sectionId}&topic=${notif?.data?.topicId}&examId=${notif?.data?._id}`;
      setShow(false);
      navigate(link);
    } else if (notif?.notificationCategory === "testAdded") {
      const link = `${txt}/myClassrooms/${notif?.classroomId}/tests?notificationConfig=true&subj=${notif?.data?.subjectId}&sec=${notif?.data?.sectionId}&topic=${notif?.data?.topicId}&examId=${notif?.data?._id}`;
      setShow(false);
      navigate(link);
    } else if (notif?.notificationCategory === "conceptVideoAdded") {
      const link = `${txt}/myClassrooms/${notif?.classroomId}/conceptvideos?notificationConfig=true&subj=${notif?.data?.subjectId}&sec=${notif?.data?.sectionId}&topic=${notif?.data?.topicId}&examId=${notif?.data?._id}`;
      setShow(false);
      navigate(link);
    } else if (notif?.notificationCategory === "lectureNoteAdded") {
      const link = `${txt}/myClassrooms/${notif?.classroomId}/lecturenotes?notificationConfig=true&subj=${notif?.data?.subjectId}&sec=${notif?.data?.sectionId}&topic=${notif?.data?.topicId}&examId=${notif?.data?._id}`;
      setShow(false);
      navigate(link);
    } else if (notif?.notificationCategory === "fullLengthExamAdded") {
      const link = `${txt}/myClassrooms/${notif?.classroomId}/full-length-exams?notificationConfig=true&assesmentId=${notif?.data?._id}`;
      setShow(false);
      navigate(link);
    } else if (notif?.notificationCategory === "subscriptionExpireReminder") {
      const link = `${txt}/myClassrooms/${notif?.classroomId}/pricing`;
      setShow(false);
      navigate(link);
    } else if (notif?.notificationCategory === "ieltsAttemptSubmitted") {
      const link = `${txt}/myClassrooms/${notif?.classroomId}/ielts-review`;
      setShow(false);
      navigate(link);
    } else if (notif?.notificationCategory === "ieltsAttemptGraded") {
      if (notif?.data?.isPractice) {
        const link = `${txt}/myClassrooms/${notif?.classroomId}/${notif?.data?.subjectId}/practice/attempt-results/${notif?.data?.examId}?activeTab=${notif?.data?.subjectId}`;
        setShow(false);
        navigate(link);
      } else {
        const sectionType = notif?.data?.sectionType;
        const attemptId = notif?.data?._id;
        if (attemptId && (sectionType === "writing" || sectionType === "speaking")) {
          const link = `${txt}/myClassrooms/${notif?.classroomId}/ielts-exams/${notif?.data?.examId}/attempt/${sectionType}/results?attemptId=${attemptId}`;
          setShow(false);
          navigate(link);
        } else {
          const link = `${txt}/myClassrooms/${notif?.classroomId}/ielts-exams/${notif?.data?.examId}`;
          setShow(false);
          navigate(link);
        }
      }
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      className="position-relative d-inline-block"
      style={{ marginRight: isMobileView ? "5px" : "15px" }}
    >
      <Button
        variant="light"
        ref={target}
        onClick={handleToggle}
        className="position-relative"
      >
        <Bell size={24} />
        {seeAbleCount > 0 && (
          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
            {seeAbleCount}
          </span>
        )}
      </Button>

      <Overlay
        target={target.current}
        show={show}
        placement="bottom-end"
        rootClose
        onHide={() => setShow(false)}
      >
        <Popover
          className="shadow border-0"
          style={{
            minWidth: "360px",
            maxWidth: "90vw",
            width: getPopoverWidth(),
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          <Popover.Header
            as="div"
            className="d-flex justify-content-between align-items-center p-3"
            style={{
              background: "linear-gradient(45deg, #007bff, #00d2ff)",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              padding: "16px 24px",
            }}
          >
            <span>🔔 Notifications</span>
            <div>
              {unreadCount > 0 && (
                <Button
                  size="sm"
                  variant="link"
                  onClick={markAllAsRead}
                  style={{
                    color: "white",
                    textDecoration: "underline",
                    fontWeight: "Normal",
                    padding: "0px",
                    textWrapMode: "nonwrap",
                  }}
                >
                  Mark All as Read
                </Button>
              )}
              <Button
                size="sm"
                variant="link"
                onClick={() => handleRedirect("/notifications/list")}
                style={{
                  color: "white",
                  textDecoration: "underline",
                  fontWeight: "Normal",
                  marginLeft: "10px",
                  padding: "0px",
                  textWrapMode: "nonwrap",
                }}
              >
                View All
                {typeof window !== "undefined" && window.innerWidth >= 1200
                  ? " Notifications"
                  : ""}
              </Button>
            </div>
          </Popover.Header>

          <Popover.Body
            style={{
              maxHeight: "350px",
              overflowY: "auto",
              padding: 0,
              overflowX: "hidden",
            }}
          >
            {notifications.length === 0 && !loading && (
              <div className="text-center p-3 text-muted">No notifications</div>
            )}

            {notifications.map((notif) => (
              <div
                key={notif.id}
                className={`d-flex justify-content-between align-items-start p-3 border-bottom notification-item ${
                  notif.hasRead ? "read" : ""
                }`}
                style={{ cursor: "pointer", transition: "background 0.3s" }}
                onClick={() => {
                  onNotificationClick(notif);
                }}
              >
                <div className="d-flex">
                  <div className="" style={{ width: "40px", flex: "none" }}>
                    {renderIcon(notif.priority, notif.notificationCategory)}
                  </div>
                  <div>
                    <div
                      className={`fw-semibold ${
                        notif.hasRead ? "text-muted" : ""
                      }`}
                    >
                      {notif.title}
                    </div>
                    <div
                      className={`small ${
                        notif.hasRead ? "text-muted" : "text-dark"
                      }`}
                    >
                      {notif.description}
                    </div>
                    <div className="text-muted small mt-1">
                      • {getRelativeTime(notif.createdAt)}
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column align-items-end ms-2">
                  {renderActionButton(notif)}
                </div>
              </div>
            ))}

            {loading && (
              <div className="text-center py-2">
                <Spinner animation="border" size="sm" />
              </div>
            )}

            {!loading && countOfPage > page + 1 && (
              <div className="text-center p-2">
                <Button
                  size="sm"
                  variant="outline-primary"
                  onClick={() => {
                    setPage(page + 1);
                  }}
                >
                  Load More
                </Button>
              </div>
            )}
          </Popover.Body>
        </Popover>
      </Overlay>

      <ToastContainer
        position="top-end"
        className="p-3"
        style={{
          zIndex: 1056,
          position: "fixed",
          top: "20px", // Reduced top
          right: "40px", // Increased right
          bottom: "unset", // Ensure bottom isn't affecting layout
          left: "unset", // Prevent stretching left
          margin: 0, // Reset margin
          maxWidth: "100vw", // Prevents overflowing horizontally
          overflow: "visible",
        }}
      >
        {toastNotification && (
          <Toast
            onClose={() => setToastNotification(null)}
            autohide
            delay={3000}
            className="notification-toast shadow border-0"
            style={{
              borderRadius: "16px",
              minWidth: "320px",
              maxWidth: "400px",
              background: "#fff",
              animation: "slideFadeIn 0.4s ease-out",
            }}
          >
            <div className="d-flex align-items-start p-3">
              {/* Icon with themed background */}
              <div
                className="shrink-0 flex-0 rounded-circle d-flex align-items-center justify-content-center me-3"
                style={{
                  width: "40px",
                  height: "40px",
                  flex: "none",
                  background:
                    toastNotification.priority === "Critical"
                      ? "rgba(220,53,69,0.1)"
                      : toastNotification.priority === "Warning"
                      ? "rgba(255,193,7,0.1)"
                      : "rgba(13,202,240,0.1)",
                }}
              >
                {toastNotification.priority === "Critical" ? (
                  <ShieldLockFill size={20} className="text-danger" />
                ) : toastNotification.priority === "Warning" ? (
                  <ExclamationTriangleFill size={20} className="text-warning" />
                ) : (
                  <Bell size={20} className="text-info" />
                )}
              </div>

              {/* Content */}
              <div className="flex-1">
                <div className="fw-semibold mb-1">
                  {toastNotification.title}
                </div>
                <div className="text-muted small">
                  {toastNotification.description}
                </div>
              </div>
            </div>
          </Toast>
        )}
      </ToastContainer>
    </div>
  );
};

export default NotificationPopover;
